import Command from "@ckeditor/ckeditor5-core/src/command";

export default class PlaceholderCommand extends Command {
  execute({ value }) {
    const editor = this.editor;

    editor.model.change(writer => {
      // Create <placeholder> elment with name attribute...
			// const showDisplayValues = editor.config.get("placeholderProps.showDisplayValues");
			// console.log("In PlaceholderCommand: value.display="+value.display+" and value.name="+value.name);
			// console.log(value);
			// var placeholderText = showDisplayValues ? value.display : value.name;
			// var placeholderText = showDisplayValues ? value.display : value.name;
			// const name = writer.createText(
					// (!placeholderText || placeholderText.trim() === "")
						// ? value.name
						// ? editor.config.get("placeholderBrackets.open") + placeholderText + editor.config.get("placeholderBrackets.close")
			// );
      const placeholder = writer.createElement("placeholder", {
        // name: name,
        "data-slug": value.slug,
        "data-field-name": value.name,
				"data-display-val": value.display
      });
			// console.log('placeholder: ');
			// console.log(placeholder);

      // ... and insert it into the document.
      editor.model.insertContent(placeholder);

      // Put the selection on inserted element.
      // writer.setSelection(placeholder, "on");
    });
  }

  refresh() {
    const model = this.editor.model;
    const selection = model.document.selection;

    const isAllowed = model.schema.checkChild(
      selection.focus.parent,
      "placeholder",
    );

    this.isEnabled = isAllowed;
  }
}
